// alert.state.ts
export interface AlertState {
    message: string;
    type: 'error' | 'success' | 'info' | 'warning';
    show: boolean;
}

export const initialAlertState: AlertState = {
    message: '',
    type: 'info',
    show: false,
};
